import React, { useCallback, useContext } from 'react';
import { SeekType } from '@24i/player-base';
import { useAdsData } from '@24i/player-utils-react';
import { PlayerUIContext, absoluteSeek, setIsOnLiveEdge } from '@24i/player-ui';
import { DVR_POINTS } from '@24i/nxg-core-utils/src/constants';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { areProgramMetadataValid } from '@24i/player-utils';
import { Button as StyledButton } from './styled';
import { StyledIcon as Icon, IconName } from '../Icons';
const RenderDefaultIcon = (buttonIconName, color, backgroundColor, styles) => {
    return (React.createElement(Icon, { name: buttonIconName, style: styles.icon, "data-test": `${buttonIconName}-Icon`, className: `${buttonIconName}-Icon`, color, backgroundColor }));
};
export const Button = ({ playerInstance, programRange, customIcon = RenderDefaultIcon, disabled, styles = {
    button: { marginRight: 24 },
    icon: null,
    backgroundColor: 'transparent',
}, iconName, onClick, }) => {
    var _a, _b;
    const { dispatch } = useContext(PlayerUIContext);
    const { isSeekingBackwardDisabled, isSeekingForwardDisabled } = useAdsData(playerInstance);
    const metadataValid = areProgramMetadataValid(programRange.start, programRange.end);
    const { theme } = useTheme();
    const finalColor = styles.color || ((_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.contrast1) || 'white';
    const finalDisabledColor = styles.disabledColor || ((_b = theme === null || theme === void 0 ? void 0 : theme.color) === null || _b === void 0 ? void 0 : _b.contrast4) || 'gray';
    const iconColor = !disabled ? finalColor : finalDisabledColor;
    const restart = useCallback(() => {
        dispatch(absoluteSeek(DVR_POINTS.START));
        if (playerInstance) {
            if (!playerInstance.live) {
                playerInstance.seek(0, SeekType.CURRENT_TIME);
            }
            else if (!metadataValid && playerInstance.timeshiftRange) {
                playerInstance.seek(playerInstance.timeshiftRange.start, SeekType.CURRENT_TIME);
            }
            else if (programRange && Number.isFinite(programRange.start)) {
                playerInstance.seek(programRange.start, SeekType.UTC);
            }
        }
    }, [playerInstance, programRange.start]);
    const goToLive = useCallback(() => {
        dispatch(absoluteSeek(DVR_POINTS.END));
        playerInstance.seek(0, SeekType.TIMESHIFT);
    }, [playerInstance]);
    const onClickHandler = useCallback((event) => {
        if (iconName === 'restart' && !isSeekingBackwardDisabled) {
            restart();
            dispatch(setIsOnLiveEdge(false));
        }
        else if (iconName === 'gotolive' && !isSeekingForwardDisabled) {
            goToLive();
            dispatch(setIsOnLiveEdge(true));
        }
        if (event && event.stopPropagation)
            event.stopPropagation();
    }, [restart, goToLive]);
    return (React.createElement(StyledButton, { style: styles.button, "data-test": `${iconName}-Button`, className: `${iconName}-Button`, onClick: onClick || onClickHandler, onDoubleClick: (event) => {
            event.stopPropagation();
            event.preventDefault();
        }, backgroundColor: styles.backgroundColor, disabled }, customIcon(IconName[iconName], iconColor, styles.backgroundColor, styles)));
};
export { StyledButton };
//# sourceMappingURL=index.js.map